import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBridgeState } from '@digitaz/bridge-sdk-client';
import { CloseIcon } from '../../../icons';
import { ButtonType } from '../../../styled/theme/types';
import { Button } from '../Button';
import { Modal } from '../Modal';
import { closeButtonStyles, mapModalStyles, saveButtonStyles } from './styled';
import { palette } from '../../../styles/_palette';
import { MapModalProps } from './types';

export const MapModal: React.FC<MapModalProps> = ({
  isOpen,
  modalId,
  children,
  onClose,
  saveCoordinates
}) => {
  const { t } = useTranslation();
  const { isWebView } = useBridgeState();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      modalId={modalId}
      modalStyles={mapModalStyles}
    >
      <Button
        onClick={onClose}
        state={ButtonType.white}
        styles={closeButtonStyles(isWebView)}
      >
        <CloseIcon fill={palette.heatheredGrey} width={15} height={15} />
      </Button>

      {saveCoordinates && (
        <Button
          onClick={saveCoordinates}
          text={t('new_ad.save')}
          styles={saveButtonStyles}
        />
      )}

      {children}
    </Modal>
  );
};
